export { renderDivider_unstable as renderToolbarDivider } from '@fluentui/react-divider';
